// skipcq: JS-W1028
import { useEffect, useState } from 'react';
import {
  collection,
  limit,
  onSnapshot,
  orderBy,
  query,
  where,
} from 'firebase/firestore';
import { db } from '../utils/firebase';
import {
  SCHEDULER_EXECUTION_REPORTS_COLLECTION,
} from '../utils/firestoreCollections';
import { buildSchedulerExecutionOutcomeFacets } from '../utils/schedulerExecutionDailyChart';

const DAILY_REPORT_LOOKBACK_COUNT = 14;

function useSchedulerExecutionDailyReports() {
  const [facets, setFacets] = useState([]);
  const [reportsLoading, setReportsLoading] = useState(true);
  const [reportsError, setReportsError] = useState(null);

  useEffect(() => {
    const reportsCollection = collection(db, SCHEDULER_EXECUTION_REPORTS_COLLECTION);
    const reportsQuery = query(
      reportsCollection,
      where('type', '==', 'daily'),
      orderBy('date', 'desc'),
      limit(DAILY_REPORT_LOOKBACK_COUNT),
    );
    const unsubscribe = onSnapshot(
      reportsQuery,
      (snapshot) => {
        const documents = snapshot.docs.map(function mapReportDocument(documentSnap) {
          const data = documentSnap.data();
          return {
            id: documentSnap.id,
            date: typeof data.date === 'string' ? data.date : '',
            metrics: typeof data.metrics === 'object' && data.metrics !== null ? data.metrics : {},
          };
        });
        setFacets(buildSchedulerExecutionOutcomeFacets(documents));
        setReportsLoading(false);
        setReportsError(null);
      },
      (subscriptionError) => {
        console.error('useSchedulerExecutionDailyReports subscription error', subscriptionError);
        setReportsError(subscriptionError);
        setReportsLoading(false);
      },
    );
    return () => unsubscribe();
  }, []);

  return {
    facets,
    loading: reportsLoading,
    error: reportsError,
  };
}

export default useSchedulerExecutionDailyReports;
